import { fetchApi } from '@/config/axiosSetting';
import {
  GetOtherDamagedDescriptionQueryParamsType,
  GetOtherDamagedDescriptionQueryResponseType,
} from '@/modules/adjusterReportModules/IncidentParticipants/queries/getOtherDamagedDescription/getOtherDamagedDescriptionQuery.type';

export const getOtherDamagedDescriptionFunction = (
  params: GetOtherDamagedDescriptionQueryParamsType,
): Promise<GetOtherDamagedDescriptionQueryResponseType> => {
  return fetchApi.get(
    `property/reports/${params.id}/accident_users/damaged/customer/other_damaged/description/`,
    { params: { damaged_id: params.damagedId } },
  );
};
